import en from './en.json';
import zhCN from './zh_CN.json';
import zhTW from './zh_TW.json';

export const resources = {
  en: { translation: en },
  zhCN: { translation: zhCN },
  zhTW: { translation: zhTW },
};
